import React from "react";
import { useTranslation } from "react-i18next";
import { capitalizeFirstLetter } from "../../../utils/commonfunction";

function PatientCenterFilter(props) {
    const { t } = useTranslation()
    let showFilterlist = [{ _id: '', center_name: 'Select Center' }];
    showFilterlist = showFilterlist.concat(props.data && props.data.length > 0 ? props.data : []);

    // const handleChange = (e) => {
    //     if (e.target.value) {
    //         props.prepareSearch("center_id", e.target.value)
    //     } else {
    //         props.prepareSearch("center_id", "")
    //     }
    // };

    const handleChange = (e) => {
        const selectedValue = e.target.value;
        if (selectedValue && selectedValue !== "null") {
            props.prepareSearch("center_id", selectedValue);
        } else {
            props.prepareSearch("center_id", null);
        }
    };

    return (
        <div className="form-group mb-0 filter_icon_container filter_design">
            <i className="fa fa-filter mr-2 filter_icon"></i>
            <div className="select-down-arrow">
                <select className="form-control cp" onChange={handleChange} id="defaultcenter">
                    {showFilterlist && showFilterlist.length > 0 && showFilterlist.map((option, i) => {
                        return (
                            <option value={option._id}>
                                {capitalizeFirstLetter(option.center_name)}
                            </option>
                        );
                    })}
                    <option value="null">N/A</option>
                </select>
            </div>

        </div>
    );
}
export default PatientCenterFilter;